/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProductionWithdrawal } from './APIProductionWithdrawal';
import {
    APIProductionWithdrawalFromJSON,
    APIProductionWithdrawalFromJSONTyped,
    APIProductionWithdrawalToJSON,
} from './APIProductionWithdrawal';

/**
 * 
 * @export
 * @interface APIPaginatedProductionWithdrawalList
 */
export interface APIPaginatedProductionWithdrawalList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedProductionWithdrawalList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedProductionWithdrawalList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedProductionWithdrawalList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIProductionWithdrawal>}
     * @memberof APIPaginatedProductionWithdrawalList
     */
    results: Array<APIProductionWithdrawal>;
}

/**
 * Check if a given object implements the APIPaginatedProductionWithdrawalList interface.
 */
export function instanceOfAPIPaginatedProductionWithdrawalList(value: object): value is APIPaginatedProductionWithdrawalList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedProductionWithdrawalListFromJSON(json: any): APIPaginatedProductionWithdrawalList {
    return APIPaginatedProductionWithdrawalListFromJSONTyped(json, false);
}

export function APIPaginatedProductionWithdrawalListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedProductionWithdrawalList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIProductionWithdrawalFromJSON)),
    };
}

export function APIPaginatedProductionWithdrawalListToJSON(value?: APIPaginatedProductionWithdrawalList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIProductionWithdrawalToJSON)),
    };
}

